(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["v2-about-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Paging inside the lightbox. It must NOT reuse data-v2-modal-open: that opener locks
       the page scroll every time it fires, and one close only unlocks once — page twice and
       the body would stay frozen. Closing first keeps the lock counter balanced.
       Liquid is not evaluated in this block, so it delegates from document. */
    if (window.__v2GalNav) return;
    window.__v2GalNav = true;

    document.addEventListener('click', function (ev) {
      var nav = ev.target.closest('[data-v2-gal-nav]');
      if (!nav) return;
      ev.preventDefault();
      var tpl = document.querySelector(nav.getAttribute('data-v2-gal-nav'));
      if (!tpl || !window.v2CloseModal || !window.v2OpenModal) return;
      window.v2CloseModal();
      window.v2OpenModal(tpl.innerHTML);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-about-pillars"] && !Shopify.designMode) return;
  try {
    
    (function () {
      /* Liquid is NOT evaluated inside {% javascript %} — this block is bundled statically for
        the whole theme, so it binds by data attribute and iterates every instance. */
      function init() {
        document.querySelectorAll('[data-v2-pillars]').forEach(function (root) {
          if (root.__v2Pillars) return;
          root.__v2Pillars = true;

          var panels = root.querySelectorAll('[data-v2-pillar-panel]');
          var active = null;

          function ids() {
            return Array.prototype.map.call(panels, function (p) {
              return p.getAttribute('data-v2-pillar-panel');
            });
          }

          function show(id) {
            active = id;
            root.classList.toggle('is-open', !!id);
            Array.prototype.forEach.call(panels, function (p) {
              p.hidden = p.getAttribute('data-v2-pillar-panel') !== id;
            });
            root.querySelectorAll('[data-v2-pillar-tab]').forEach(function (t) {
              var on = t.getAttribute('data-v2-pillar-tab') === id;
              t.classList.toggle('is-active', on);
              if (t.hasAttribute('aria-expanded')) t.setAttribute('aria-expanded', on ? 'true' : 'false');
            });
          }

          root.addEventListener('click', function (ev) {
            var tab = ev.target.closest('[data-v2-pillar-tab]');
            if (tab && root.contains(tab)) {
              ev.preventDefault();
              var id = tab.getAttribute('data-v2-pillar-tab');
              show(id === active ? null : id);
              return;
            }
            var next = ev.target.closest('[data-v2-pillar-next]');
            if (next && root.contains(next)) {
              ev.preventDefault();
              var list = ids();
              if (!list.length) return;
              var i = list.indexOf(active);
              show(list[(i + 1) % list.length]);
            }
          });

          document.addEventListener('v2:escape', function () {
            if (active) show(null);
          });
        });
      }

      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
      else init();
      document.addEventListener('shopify:section:load', init);
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-article-body"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('.v2-article-body').forEach(function (root) {
        if (root.__v2Share) return;
        root.__v2Share = true;

        var btn = root.querySelector('[data-v2-share]');
        if (!btn) return;

        var labelEl = btn.querySelector('[data-v2-share-label]');
        var original = labelEl ? labelEl.textContent : '';

        btn.addEventListener('click', function () {
          var url = window.location.href;

          if (navigator.share) {
            navigator.share({ title: document.title, url: url }).catch(function () {});
            return;
          }

          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url).then(function () {
              if (!labelEl) return;
              labelEl.textContent = btn.getAttribute('data-copied-label') || original;
              setTimeout(function () { labelEl.textContent = original; }, 2000);
            }, function () {});
          }
        });
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-consultation-popup"]) return;
  try {
    
  (function () {
    var KEY = 'v2SeenConsultation';

    function init() {
      var el = document.querySelector('[data-v2-consult]');
      if (!el || el.__v2) return;
      el.__v2 = true;

      /* Open the shared form. It may not have registered yet on a slow load; try again. */
      var open = function () {
        if (typeof window.bteOpenInquiry !== 'function') { setTimeout(open, 250); return; }
        if (document.querySelector('.bte-inq.is-open')) return;
        window.bteOpenInquiry(null, 'Auto popup');
        try { localStorage.setItem(KEY, '1'); } catch (e) {}
      };

      if (el.getAttribute('data-enabled') !== 'true') return;
      /* Never interrupt someone who has just submitted. */
      if (location.search.indexOf('_posted=true') !== -1) return;

      var seen = false;
      try { seen = localStorage.getItem(KEY) === '1'; } catch (e) {}
      if (seen) return;

      var delay = (parseInt(el.getAttribute('data-delay'), 10) || 30) * 1000;
      var pct = parseInt(el.getAttribute('data-scroll'), 10) || 60;
      var timer = setTimeout(open, delay);

      var onScroll = function () {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        /* A short page reaches 60% instantly; require a real page's worth of scrolling. */
        if (max < 600) return;
        if ((window.scrollY / max) * 100 > pct) {
          clearTimeout(timer);
          window.removeEventListener('scroll', onScroll);
          open();
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-header"]) return;
  try {
    
  (function () {
    /* Liquid is NOT evaluated inside {% javascript %} — Shopify compiles these blocks into one
       shared static bundle. So this must never reference section.id; it binds by class/attribute
       and iterates every instance instead. */
    function init() {
      document.querySelectorAll('[data-v2-nav]').forEach(function (nav) {
        if (nav.__v2) return;
        nav.__v2 = true;

        var onScroll = function () {
          nav.classList.toggle('is-scrolled', window.scrollY > 50);
        };
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });

        /* Dropdowns: hover on pointer devices, click everywhere (keyboard + touch). */
        nav.querySelectorAll('[data-v2-drop]').forEach(function (drop) {
          var btn = drop.querySelector('[data-v2-drop-btn]');
          var open = function (state) {
            drop.classList.toggle('is-open', state);
            if (btn) btn.setAttribute('aria-expanded', state ? 'true' : 'false');
          };
          drop.addEventListener('mouseenter', function () { open(true); });
          drop.addEventListener('mouseleave', function () { open(false); });
          if (btn) {
            btn.addEventListener('click', function (e) {
              e.preventDefault();
              open(!drop.classList.contains('is-open'));
            });
          }
          drop.addEventListener('focusout', function (e) {
            if (!drop.contains(e.relatedTarget)) open(false);
          });
        });

        document.addEventListener('v2:escape', function () {
          nav.querySelectorAll('[data-v2-drop].is-open').forEach(function (d) {
            d.classList.remove('is-open');
            var b = d.querySelector('[data-v2-drop-btn]');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
        });

        /* Mobile sheet */
        var burger = nav.querySelector('[data-v2-burger]');
        if (!burger) return;
        var sheet = document.getElementById(burger.getAttribute('aria-controls'));
        if (!sheet) return;
        var iOpen = burger.querySelector('[data-v2-burger-open]');
        var iClose = burger.querySelector('[data-v2-burger-close]');

        var setSheet = function (state) {
          sheet.hidden = !state;
          burger.setAttribute('aria-expanded', state ? 'true' : 'false');
          if (iOpen) iOpen.hidden = state;
          if (iClose) iClose.hidden = !state;
          if (state) { window.v2Lock && window.v2Lock(); }
          else { window.v2Unlock && window.v2Unlock(); }
        };

        burger.addEventListener('click', function () { setSheet(sheet.hidden); });
        var scrim = sheet.querySelector('[data-v2-burger-scrim]');
        if (scrim) scrim.addEventListener('click', function () { setSheet(false); });
        sheet.querySelectorAll('a').forEach(function (a) {
          a.addEventListener('click', function () { setSheet(false); });
        });
        document.addEventListener('v2:escape', function () {
          if (!sheet.hidden) setSheet(false);
        });
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-home-hero"] && !Shopify.designMode) return;
  try {
    

(function () {

  /*
    ============================================================
    HOME HERO INITIALIZER
    ============================================================
  */

  function initHero(hero) {

    if (
      !hero ||
      hero.__v2HeroInitialized
    ) {

      return;

    }


    hero.__v2HeroInitialized =
      true;


    var reduceMotion =
      window.matchMedia &&
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;



    /*
      ==========================================================
      CONTENT REVEAL
      ==========================================================
    */

    var revealItems =
      hero.querySelectorAll(
        '[data-v2-reveal]'
      );


    if (
      reduceMotion
    ) {

      revealItems.forEach(
        function (item) {

          item.classList.add(
            'is-visible'
          );

        }
      );

    } else {

      hero.classList.add(
        'is-v2-ready'
      );


      requestAnimationFrame(
        function () {

          requestAnimationFrame(
            function () {

              revealItems.forEach(
                function (item) {

                  item.classList.add(
                    'is-visible'
                  );

                }
              );

            }
          );

        }
      );

    }



    /*
      ==========================================================
      BACKGROUND VIDEO
      ==========================================================
    */

    var video =
      hero.querySelector(
        '.v2-home-hero__video-wrap video'
      );


    if (
      video
    ) {

      /*
        Explicitly reinforce attributes required by mobile
        autoplay policies.
      */

      video.muted =
        true;


      video.defaultMuted =
        true;


      video.loop =
        true;


      video.setAttribute(
        'muted',
        ''
      );


      video.setAttribute(
        'playsinline',
        ''
      );


      video.setAttribute(
        'webkit-playsinline',
        ''
      );


      var tryPlayVideo =
        function () {

          if (
            !video.paused
          ) {

            return;

          }


          var playPromise =
            video.play();


          if (
            playPromise &&
            typeof playPromise.catch ===
            'function'
          ) {

            playPromise.catch(
              function () {}
            );

          }

        };


      tryPlayVideo();


      /*
        iOS Low Power Mode (and some data-saver modes) block
        autoplay no matter what attributes are set. The moment
        the visitor touches, taps or scrolls the page, retry —
        this clears the native "tap to play" overlay without
        any visible UI change for everyone else.
      */

      var gestureEvents = [
        'touchstart',
        'click',
        'scroll'
      ];


      var onGesture =
        function () {

          tryPlayVideo();


          if (
            !video.paused
          ) {

            gestureEvents.forEach(
              function (name) {

                window.removeEventListener(
                  name,
                  onGesture
                );

              }
            );

          }

        };


      gestureEvents.forEach(
        function (name) {

          window.addEventListener(
            name,
            onGesture,
            { passive: true }
          );

        }
      );


      document.addEventListener(
        'visibilitychange',
        function () {

          if (
            !document.hidden
          ) {

            tryPlayVideo();

          }

        }
      );


      window.addEventListener(
        'pageshow',
        tryPlayVideo
      );

    }



    /*
      ==========================================================
      PHOTO SLIDESHOW

      Only runs when there is no background video.
      ==========================================================
    */

    var slides =
      hero.querySelectorAll(
        '.v2-home-hero__slide'
      );


    if (
      !video &&
      slides.length > 1 &&
      !reduceMotion
    ) {

      var interval =
        parseFloat(
          hero.getAttribute(
            'data-v2-hero-interval'
          )
        );


      if (
        !interval ||
        interval < 1000
      ) {

        interval =
          5500;

      }


      var currentSlide =
        0;


      hero.__v2SlideTimer =
        window.setInterval(
          function () {

            slides[
              currentSlide
            ].classList.remove(
              'is-active'
            );


            currentSlide =
              (
                currentSlide + 1
              ) %
              slides.length;


            slides[
              currentSlide
            ].classList.add(
              'is-active'
            );

          },
          interval
        );

    }



    /*
      ==========================================================
      PARALLAX

      Preserves the original slow background drift on:
      - uploaded video
      - slideshow photos
      - fallback photo
      ==========================================================
    */

    if (
      !reduceMotion
    ) {

      var parallaxItems =
        hero.querySelectorAll(
          '.v2-home-hero__slide, .v2-home-hero__video-wrap video, .v2-home-hero__fallback-image img'
        );


      if (
        parallaxItems.length
      ) {

        var ticking =
          false;


        var applyParallax =
          function () {

            var heroRect =
              hero.getBoundingClientRect();


            var viewportHeight =
              window.innerHeight ||
              document.documentElement.clientHeight;


            if (
              heroRect.bottom > 0 &&
              heroRect.top <
              viewportHeight *
              1.2
            ) {

              /*
                Because the hero now begins below the header,
                calculate motion relative to its own position.
              */

              var traveled =
                Math.max(
                  0,
                  -heroRect.top
                );


              var movement =
                traveled *
                0.18;


              var transform =
                'translate3d(0,' +
                movement +
                'px,0) scale(1.06)';


              parallaxItems.forEach(
                function (item) {

                  item.style.transform =
                    transform;

                }
              );

            }


            ticking =
              false;

          };


        window.addEventListener(
          'scroll',
          function () {

            if (
              ticking
            ) {

              return;

            }


            ticking =
              true;


            window.requestAnimationFrame(
              applyParallax
            );

          },
          {
            passive:
              true
          }
        );


        applyParallax();

      }

    }

  }



  /*
    ============================================================
    INITIALIZE ALL HERO INSTANCES
    ============================================================
  */

  function initAllHeroes() {

    document
      .querySelectorAll(
        '[data-v2-hero]'
      )
      .forEach(
        function (hero) {

          initHero(
            hero
          );

        }
      );

  }



  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAllHeroes
    );

  } else {

    initAllHeroes();

  }



  /*
    ============================================================
    SHOPIFY THEME EDITOR SUPPORT
    ============================================================
  */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      var hero =
        event.target.querySelector(
          '[data-v2-hero]'
        );


      if (
        hero
      ) {

        initHero(
          hero
        );

      }

    }
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-home-pillars"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('[data-v2-pillars]').forEach(function (root) {
        if (root.__v2Pillars) return;
        root.__v2Pillars = true;

        var select = function (idx) {
          root.querySelectorAll('[data-v2-pillar]').forEach(function (el) {
            var on = el.getAttribute('data-v2-pillar') === idx;
            el.classList.toggle('is-active', on);
            if (el.hasAttribute('aria-pressed')) el.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
        };

        root.addEventListener('click', function (ev) {
          var btn = ev.target.closest('button[data-v2-pillar]');
          if (!btn || !root.contains(btn)) return;
          select(btn.getAttribute('data-v2-pillar'));
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-prog-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('[data-v2-progfilter]').forEach(function (root) {
        if (root.__v2Filter) return;
        root.__v2Filter = true;

        var apply = function (key) {
          root.querySelectorAll('[data-v2-filter]').forEach(function (b) {
            var on = b.getAttribute('data-v2-filter') === key;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          root.querySelectorAll('[data-v2-prog]').forEach(function (card) {
            var show = key === 'all' || card.getAttribute('data-v2-prog-filter') === key;
            card.classList.toggle('is-filtered', !show);
          });
        };

        root.addEventListener('click', function (ev) {
          var btn = ev.target.closest('[data-v2-filter]');
          if (!btn || !root.contains(btn)) return;
          apply(btn.getAttribute('data-v2-filter'));
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-ref-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* No Liquid in here — Shopify compiles every {% javascript %} block into one shared static
       bundle and never evaluates Liquid inside it. The playlist URL and the library URL both
       arrive as data attributes on the element. */
    function attach(root) {
      if (root.__v2hls) return;
      root.__v2hls = true;

      var video = root.querySelector('video');
      var play = root.querySelector('.v2-ref-video__play');
      var src = root.getAttribute('data-v2-hls');
      var lib = root.getAttribute('data-v2-hls-lib');
      if (!video || !src) return;

      var started = false;

      function start() {
        if (started) return;
        started = true;
        root.classList.add('is-loading');

        // Safari (and iOS) plays HLS natively; no library needed.
        if (video.canPlayType('application/vnd.apple.mpegurl')) {
          video.src = src;
          begin();
          return;
        }

        if (window.Hls) return begin(true);

        var s = document.createElement('script');
        s.src = lib;
        s.onload = function () { begin(true); };
        s.onerror = function () {
          // Never leave the visitor staring at a dead play button.
          root.classList.remove('is-loading');
          started = false;
          window.open(src, '_blank', 'noopener');
        };
        document.head.appendChild(s);
      }

      function begin(useLib) {
        if (useLib) {
          if (!window.Hls || !window.Hls.isSupported()) {
            root.classList.remove('is-loading');
            video.src = src;
          } else {
            var hls = new window.Hls({ capLevelToPlayerSize: true });
            hls.loadSource(src);
            hls.attachMedia(video);
          }
        }
        root.classList.remove('is-loading');
        root.classList.add('is-playing');
        var p = video.play();
        if (p && p.catch) p.catch(function () { /* autoplay blocked — controls are visible */ });
      }

      if (play) play.addEventListener('click', start);
      video.addEventListener('play', start);
    }

    function init() {
      document.querySelectorAll('[data-v2-hls]').forEach(attach);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-scholars-hero"] && !Shopify.designMode) return;
  try {
    
  /* No Liquid in here — Shopify bundles these blocks statically. Mirrors the
     `heroOffset * 0.3` parallax in the TSX. */
  (function () {
    function init() {
      document.querySelectorAll('.v2-scholars-hero [data-v2-parallax]').forEach(function (bg) {
        if (bg.__v2Parallax) return;
        bg.__v2Parallax = true;
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        var ticking = false;
        var apply = function () {
          ticking = false;
          var host = bg.closest('section');
          if (!host) return;
          var top = host.getBoundingClientRect().top + window.scrollY;
          var shift = (window.scrollY - top) * 0.3;
          if (shift < 0) shift = 0;
          bg.style.transform = 'translateY(' + shift + 'px) scale(1.05)';
        };
        var onScroll = function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(apply);
        };
        apply();
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-school-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('[data-v2-journey]').forEach(function (bar) {
        if (bar.__v2journey) return;
        bar.__v2journey = true;

        var links = Array.prototype.slice.call(bar.querySelectorAll('[data-v2-journey-link]'));
        if (!links.length) return;

        var targets = links.map(function (a) {
          var href = a.getAttribute('href') || '';
          if (href.charAt(0) !== '#') return null;
          try { return document.querySelector(href); } catch (e) { return null; }
        });

        var onScroll = function () {
          var pos = window.scrollY + 120;
          var current = -1;
          targets.forEach(function (el, i) {
            if (el && el.getBoundingClientRect().top + window.scrollY <= pos) current = i;
          });
          links.forEach(function (a, i) { a.classList.toggle('is-active', i === current); });
        };
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-store-grid"] && !Shopify.designMode) return;
  try {
    
  /* Liquid is NOT evaluated inside {% javascript %} — bind by attribute and iterate every
     instance instead of referencing section.id. */
  (function () {
    function init() {
      document.querySelectorAll('.v2-store-grid').forEach(function (root) {
        if (root.__v2Store) return;
        root.__v2Store = true;

        var buttons = root.querySelectorAll('[data-v2-store-filter]');
        var items = root.querySelectorAll('[data-v2-store-item]');
        if (!buttons.length) return;

        var ON = ['bg-forest-500', 'text-cream-50', 'shadow-md'];
        var OFF = ['bg-cream-100', 'text-bark-600', 'hover:bg-mint-100/60'];

        function paint(btn, active) {
          ON.forEach(function (c) { btn.classList.toggle(c, active); });
          OFF.forEach(function (c) { btn.classList.toggle(c, !active); });
          btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        }

        function apply(value) {
          buttons.forEach(function (b) { paint(b, b.getAttribute('data-v2-store-filter') === value); });
          items.forEach(function (item) {
            var match = value === '*' || item.getAttribute('data-v2-store-cat') === value;
            item.style.display = match ? '' : 'none';
          });
        }

        buttons.forEach(function (btn) {
          btn.addEventListener('click', function () {
            apply(btn.getAttribute('data-v2-store-filter'));
          });
        });
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-team-roster"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Liquid is NOT evaluated inside {% javascript %} — this block is bundled statically for
       the whole theme, so it binds by data attribute and iterates every instance. */
    function init() {
      document.querySelectorAll('[data-v2-roster]').forEach(function (root) {
        if (root.__v2Roster) return;
        root.__v2Roster = true;

        var chips = root.querySelectorAll('[data-v2-filter]');
        if (!chips.length) return;
        var cards = root.querySelectorAll('[data-v2-spec]');

        root.addEventListener('click', function (ev) {
          var chip = ev.target.closest('[data-v2-filter]');
          if (!chip || !root.contains(chip)) return;
          ev.preventDefault();
          var want = chip.getAttribute('data-v2-filter');

          Array.prototype.forEach.call(chips, function (c) {
            c.classList.toggle('is-active', c === chip);
          });
          Array.prototype.forEach.call(cards, function (card) {
            var match = !want || card.getAttribute('data-v2-spec') === want;
            card.classList.toggle('is-filtered', !match);
          });
        });
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-testi-parents"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Liquid is NOT evaluated inside a javascript block — Shopify concatenates them into one
       static theme-wide bundle. So this binds by class/data attribute and iterates every
       instance rather than referencing section.id. */
    function init() {
      document.querySelectorAll('.v2-testi-parents').forEach(function (root) {
        if (root.__v2Carousel) return;

        var track = root.querySelector('[data-v2-carousel-track]');
        if (!track) return;
        var slides = track.querySelectorAll('.v2-testi-parents__slide');
        if (slides.length < 2) return;

        root.__v2Carousel = true;
        root.classList.add('is-live');

        var dots = root.querySelectorAll('[data-v2-carousel-go]');
        var active = 0;
        var timer = null;
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        function show(i) {
          active = (i + slides.length) % slides.length;
          for (var s = 0; s < slides.length; s++) {
            slides[s].classList.toggle('is-active', s === active);
          }
          for (var d = 0; d < dots.length; d++) {
            dots[d].className = 'h-2 rounded-full transition-all duration-300 ' +
              (d === active ? 'w-8 bg-forest-500' : 'w-2 bg-bark-200 hover:bg-bark-300');
            dots[d].setAttribute('aria-current', d === active ? 'true' : 'false');
          }
          var q = slides[active].querySelector('[data-v2-carousel-quote]');
          if (q && !reduce) {
            q.classList.remove('animate-reveal-up');
            void q.offsetWidth;
            q.classList.add('animate-reveal-up');
          }
        }

        function stop() { if (timer) { clearInterval(timer); timer = null; } }
        function start() {
          if (reduce) return;
          stop();
          timer = setInterval(function () { show(active + 1); }, 6000);
        }

        var prev = root.querySelector('[data-v2-carousel-prev]');
        var next = root.querySelector('[data-v2-carousel-next]');
        if (prev) prev.addEventListener('click', function () { show(active - 1); start(); });
        if (next) next.addEventListener('click', function () { show(active + 1); start(); });
        for (var k = 0; k < dots.length; k++) {
          (function (btn) {
            btn.addEventListener('click', function () {
              show(parseInt(btn.getAttribute('data-v2-carousel-go'), 10) || 0);
              start();
            });
          })(dots[k]);
        }

        root.addEventListener('mouseenter', stop);
        root.addEventListener('mouseleave', start);
        root.addEventListener('focusin', stop);
        root.addEventListener('focusout', start);

        show(0);
        start();
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-video-band"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* iOS Low Power Mode (and some data-saver modes) block muted autoplay no matter what
       attributes ship in the markup, leaving a frozen first frame. Retry play() on the
       first touch/tap/scroll, when the tab returns, and on pageshow — the retry is a
       no-op once the film is rolling, so it costs everyone else nothing.
       Liquid is not evaluated in this block; films meant to autoplay are the <video>
       tags that carry the autoplay attribute (see the markup above). */
    function init() {
      document.querySelectorAll('.v2-video-band').forEach(function (root) {
        if (root.__v2VideoBand) return;
        root.__v2VideoBand = true;

        root.querySelectorAll('video.v2-video-band__media[autoplay]').forEach(function (video) {
          video.muted = true;
          video.defaultMuted = true;
          video.setAttribute('muted', '');
          video.setAttribute('playsinline', '');
          video.setAttribute('webkit-playsinline', '');

          var tryPlayVideo = function () {
            if (!video.paused) return;
            var playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(function () {});
            }
          };

          tryPlayVideo();

          var gestureEvents = ['touchstart', 'click', 'scroll'];
          var onGesture = function () {
            tryPlayVideo();
            if (!video.paused) {
              gestureEvents.forEach(function (name) {
                window.removeEventListener(name, onGesture);
              });
            }
          };
          gestureEvents.forEach(function (name) {
            window.addEventListener(name, onGesture, { passive: true });
          });

          document.addEventListener('visibilitychange', function () {
            if (!document.hidden) tryPlayVideo();
          });
          window.addEventListener('pageshow', tryPlayVideo);
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-wild-hero"] && !Shopify.designMode) return;
  try {
    
  /* No Liquid in here — Shopify bundles these blocks statically. Binds by attribute and
     iterates every instance. Mirrors the `heroOffset * 0.3` parallax in the TSX. */
  (function () {
    function init() {
      document.querySelectorAll('.v2-wild-hero [data-v2-parallax]').forEach(function (bg) {
        if (bg.__v2Parallax) return;
        bg.__v2Parallax = true;
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        var ticking = false;
        var apply = function () {
          ticking = false;
          var host = bg.closest('section');
          if (!host) return;
          var top = host.getBoundingClientRect().top + window.scrollY;
          var shift = (window.scrollY - top) * 0.3;
          if (shift < 0) shift = 0;
          bg.style.transform = 'translateY(' + shift + 'px) scale(1.05)';
        };
        var onScroll = function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(apply);
        };
        apply();
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-wild-journey"] && !Shopify.designMode) return;
  try {
    
  /* No Liquid in here — Shopify bundles these blocks statically. Binds by attribute. */
  (function () {
    function init() {
      document.querySelectorAll('[data-v2-journey]').forEach(function (nav) {
        if (nav.__v2Journey) return;
        nav.__v2Journey = true;

        var links = Array.prototype.slice.call(nav.querySelectorAll('[data-v2-journey-link]'));
        if (!links.length) return;

        var targets = links.map(function (a) {
          var hash = a.getAttribute('href') || '';
          if (hash.charAt(0) !== '#' || hash.length < 2) return null;
          try { return document.querySelector(hash); } catch (e) { return null; }
        });

        var OFFSET = 70;

        links.forEach(function (a, i) {
          a.addEventListener('click', function (ev) {
            var el = targets[i];
            if (!el) return;
            ev.preventDefault();
            var top = el.getBoundingClientRect().top + window.scrollY - OFFSET;
            window.scrollTo({ top: top, behavior: 'smooth' });
          });
        });

        var ticking = false;
        var spy = function () {
          ticking = false;
          var pos = window.scrollY + 120;
          var current = 0;
          targets.forEach(function (el, i) {
            if (!el) return;
            var top = el.getBoundingClientRect().top + window.scrollY;
            if (top <= pos) current = i;
          });
          links.forEach(function (a, i) {
            a.classList.toggle('is-active', i === current);
            if (i === current) a.setAttribute('aria-current', 'true');
            else a.removeAttribute('aria-current');
          });
        };
        var onScroll = function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(spy);
        };
        spy();
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
